import 'react-multi-carousel/lib/styles.css';
import './LinkBricks.css';

// 导入图片
import img1 from '../../assets/img/Nose1.jpg';
import img2 from '../../assets/img/Nose2.jpg';
import img3 from '../../assets/img/Nose3.png';
import img4 from '../../assets/img/Nose4.png';
import img5 from '../../assets/img/Nose5.jpg';

import img7 from '../../assets/img/Nose7.jpg';
import img8 from '../../assets/img/Nose8.jpg';

export const Electronic_nose = () => {
  return (
    <div>
      {/* 主题背景图 */}
      <div className="hero-image" style={{ backgroundImage: `url(${img8})` }}>
      </div>

      {/* 项目背景模块 */}
      <section className="section">
        <h2 className="section-title">Project Background</h2>
        <p className="section-text">
          In my research group at the laboratory, I have participated in several research directions, including the development of novel gas sensors and detection methods, hardware design and development of electronic noses, odor visualization design, and olfactory-related human-computer interaction applications. Using the sense of smell as a focal point, the primary goal is to develop advanced electronic noses and explore their practical applications within the context of the Internet of Things (IoT). The long-term objective involves understanding deeper layers of olfactory information to grant machines capabilities analogous to human smell, enabling machines to better comprehend human behaviors and environmental changes, thus facilitating more natural interaction experiences.
        </p>
      </section>

      {/* Interaction Map Section */}
      <section className="section">
        <h2 className="section-title">Odor Visualization</h2>

        <div className="image-container-vertical">
          <img src={img7} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <p className="image-description">
            This work closely integrates visualization and interaction, enabling users to flexibly cluster large-scale odor data, analyze similarities and differences among various odors, enhance understanding of chemical properties and sensory attributes, and facilitate personalized odor recommendations. Future work will incorporate electronic nose array data for more comprehensive odor analysis and explore visualizing heterogeneous odors as networks to construct odor knowledge graphs.
          </p>
        </div>
      </section>

      {/* Fruit Decay Exploration Experiment Section */}
      <section className="section">
        <h2 className="section-title">Fruit Decay Exploration Experiment</h2>

        <div className="image-container-vertical">
          <img src={img3} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img4} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img1} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <p className="image-description">
            Utilizing a self-developed electronic nose to intelligently detect the decay level of fruits sold by Freshippo (Hema), reducing labor management costs and enhancing fruit quality. Two banana decay detection experiments have been conducted: achieving 95% accuracy in identifying decay in a banana-only environment, and 98% accuracy in a mango-interfered environment, demonstrating the electronic nose's feasibility as a decay detection tool. Future experiments will include larger scales and more fruit varieties.
          </p>
        </div>
      </section>

      {/* Electronic Nose Section */}
      <section className="section">
        <h2 className="section-title">Electronic Nose</h2>

        <div className="image-container-vertical">
          <img src={img2} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <img src={img5} alt="Exhibition" className="project-image-vertical no-hover-effect" />
          <p className="image-description">
            By exploring how air conditions in natural environments affect olfactory experiences, this project aims to build a multimodal odor playback system. This enhances immersion in virtual reality, offering a broader range of sensory stimulation for realistic olfactory experiences.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Electronic_nose;